
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/blue-beetle",
      function () {
        return require("private-next-pages/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/blue-beetle/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/blue-beetle"])
      });
    }
  